
import EventEmitter from 'eventemitter2';

const state = {
  RUNNING: 'running',
  COMPLETED: 'completed',
  ABORTED: 'aborted',
  FAILED: 'failed'
};

class Progress extends EventEmitter {

  get total() {
    return this._total;
  }

  get current() {
    return this._current;
  }

  get percent() {
    return this._current / this._total * 100;
  }

  get isComleted() {
    return this._isCompleted;
  }

  get isFailed() {
    return this._isFailed;
  }

  get isAborted() {
    return this._isAborted;
  }

  constructor() {
    super();

    this._total = 0;
    this._current = 0;

    this._isCompleted = false;
    this._isFailed = false;
    this._isAborted = false;
  }

  start(total) {
    this._total = total;
  }

  update(current) {
    this._current = current;
  }

  complete() {
    this._isCompleted = true;
  }

  fail() {
    this._isFailed = true;
  }

  abort() {
    this._isAborted = true;
  }

}

export default Progress;



// WEBPACK FOOTER //
// ./src/js/app/utils/progress/progress.js